import React from 'react'
import inputComponents from '../inputs/inputComponents'
import SwitchButton from '../useful/SwitchButton'
import HelpButton from '../HelpButton'
import { checkConditionGroup, checkOperator, checkTextTranslation, checkTranslation, checkValueForFormVariables, getObject, setObject } from '../../utils/useful'
import NumberInput from '../inputs/NumberInput'

class AnswerSheetForm extends React.Component {
    state = {
        errors: {},
        data: {},
        scoreData: {},
        valid: {},
        dependencies: {},
        currentPage: null,
        headers: [],
        lastPages: [],
        hiddenSections: {},
        width: this.props.width
    }

    componentDidMount() {
        // console.log('scooreeeeeeeee', this.props.scoreData);
        if (this.props.scoreData) {
            let scoreData = this.props.scoreData
            this.setState({ scoreData }, () => {
            })
        }
        // console.log("componentDidMountFormViewer", this.props.initData)
        this.init()
        window.addEventListener('resize', this.setFormWidth);
        this.setFormWidth()

        setTimeout(() => {
            this.setFormWidth()
        }, 100);

        setTimeout(() => {
            this.setFormWidth()
        }, 200);

        setTimeout(() => {
            this.setFormWidth()
        }, 300);

        setTimeout(() => {
            this.setFormWidth()
        }, 400);

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.setFormWidth)
    }

    componentDidUpdate(prevProps) {

        if ((JSON.stringify(this.props.initData) != JSON.stringify(prevProps.initData)) || (JSON.stringify(this.props.scoreInitData) !== JSON.stringify(prevProps.scoreInitData)) || (JSON.stringify(this.props.headers) !== JSON.stringify(prevProps.headers))) {
            this.init()
        }

        if (this.props.width != prevProps.width) {
            this.setFormWidth()
        }

        // if(JSON.parse(JSON.stringify(this.props.scoreData))!=JSON.parse(JSON.stringify(prevProps.scoreData))){
        //     this.setState({scoreData:this.props.scoreData})
        // }
    }



    checkDependencies = () => {

        this.state.dependencies = {}

        // console.log("checkDependencies")

        if (this.state.headers) {


            this.state.headers.forEach(header => {
                let hasDependency = (header.dependencies && header.dependencies.length > 0)



                if (hasDependency) {
                    let dependencies = this.state.dependencies

                    // console.log(dependencies)

                    header.dependencies.forEach(dependency => {


                        let newDependency = JSON.parse(JSON.stringify(dependency))
                        newDependency.target = header.key

                        if (Array.isArray(dependency.refKey)) {
                            let refkeis = dependency.refKey
                            refkeis.forEach(refkeyi => {
                                if (!dependencies[refkeyi]) {
                                    dependencies[refkeyi] = []
                                }

                                dependencies[refkeyi].push(newDependency)

                            })
                        } else {
                            if (!dependencies[dependency.refKey]) {
                                dependencies[dependency.refKey] = []
                            }

                            dependencies[dependency.refKey].push(newDependency)
                        }

                        this.state.dependencies = dependencies
                        // console.log(dependencies)

                    })
                }
            })

            if (this.state.data && this.props.headers) {


                this.props.headers.forEach(prop => {
                    this.changeDependency(prop.key, this.state.data[prop.key], true)
                })
                this.changeDependency('_id', this.state.data["_id"], true)

                this.changeDependency('*', null, true)

            }
        }
    }



    changeDependency(key, value, init) {
        let dependencies = this.state.dependencies

        // console.log("changeDependency")
        // console.log("key,",key)

        // console.log(dependencies)

        if (dependencies[key]) {





            dependencies[key].forEach(dependency => {

                let isEffected = false
                let conditions = dependency.conditions
                if (!Array.isArray(conditions)) {
                    conditions = [conditions]
                }

                conditions.forEach(condition => {
                    this.goForCondition(dependency, condition, (effected) => {
                        if (effected) {
                            isEffected = true
                        }
                    })
                })

                if (!isEffected) {

                    // console.log("Else")
                    let headers = this.state.headers
                    let variables = { data: this.state.data }


                    if (dependency.else) {
                        // console.log("dependency.else")

                        this.doEffect(dependency, dependency.else, variables, true)

                    } else {
                        if (dependency.show != null) {
                            headers.forEach(header => {
                                if (dependency.targetKey == header.key) {
                                    header.hideComponent = dependency.show
                                }
                            });
                            this.setState({ headers })
                        }
                    }
                }

            });

            this.setState({ dependencies })

        }
    }

    goForCondition(dependency, condition, cb) {
        // let condition = dependencies.condition
        let variables = { data: this.state.data }
        let result = checkConditionGroup(condition.root, variables)

        if (dependency.refKey == 'requests') {
            console.log("condition.root", condition.root)
            console.log(variables)
            console.log(result)

        }

        if (result) {

            // console.log("EFFECT")

            let effect = condition.effect ?? dependency

            this.doEffect(dependency, effect, variables, result)
        }


        cb(result)

    }


    doEffect(dependency, effect, variables, result) {

        let headers = this.state.headers

        if (effect.show != null) {
            headers.forEach(header => {
                if (dependency.targetKey == header.key) {
                    // console.log("Hide",result ? !effect.show : effect.show)
                    // console.log("effect",effect)

                    header.hideComponent = result ? !effect.show : effect.show
                }
            });
            // this.setState({ headers })
        }

        if (effect?.changeValue != null) {
            let data = this.state.data
            data[dependency.targetKey] = data[dependency.refKey]
            this.setState({ data })
        }


        let changeHeaders = effect?.changeHeader

        if (changeHeaders != null) {

            if (!Array.isArray(changeHeaders)) {
                changeHeaders = [changeHeaders]
            }

            changeHeaders.forEach(changeHeader => {
                headers.forEach(header => {
                    if (dependency.targetKey == header.key) {
                        // console.log(checkValueForFormVariables(dependency.changeHeader.value, variables))
                        // console.log(dependency.changeHeader.value)
                        // console.log(variables)
                        let newValue = checkValueForFormVariables(changeHeader.value, variables)
                        // console.log(newValue)
                        if (changeHeader?.converts) {
                            newValue = this.convertObject(newValue, changeHeader?.converts)
                        }
                        setObject(header, changeHeader.key, newValue)
                    }
                })

            })
            // this.setState({ headers })
        }



        if (dependency.init != null) {
            if (this["component-" + dependency.targetKey] && this["component-" + dependency.targetKey].init) {
                this["component-" + dependency.targetKey].init()
            }
        }

        this.setState({ headers })

    }


    convertObject = (object, convert) => {
        let newObject

        if (Array.isArray(object)) {

            newObject = []
            object.forEach(oneInArray => {
                let tempNewObject = this.convertOneOfObject(oneInArray, convert)
                newObject.push(tempNewObject)
            });
        } else {
            newObject = this.convertOneOfObject(object, convert)
        }
        // console.log("return")
        return newObject

    }

    convertOneOfObject(object, convert) {
        let newObject = { ...object }
        convert.forEach(oneConvert => {
            newObject[oneConvert.targetKey] = newObject[oneConvert.valueKey]
        })

        // convert.forEach(oneConvert => {
        //     delete newObject[oneConvert.valueKey]
        // })


        return newObject
    }



    getForm = () => {
        // console.log('this.state.headers, this.state.data', this.validator(this.state.headers, this.state.data))
        if (this.validator(this.state.headers, this.state.data).valid) {
            // console.log('dataaaaaaaa', this.state.data)
            // return
            let answers = this.state.data ? this.state.data : {}
            let scores = this.state.scoreData ? this.state.scoreData : {}
            return { answers, scores }
        } else {
            return null
        }
    }



    init = (currentPage) => {
        // console.log("***init")
        this.setFormWidth()

        if (this.props.headers) {
            let headers = JSON.parse(JSON.stringify(this.props.headers))
            let visibleHeaders = []

            if (this.props.pages && this.props?.pages.length > 0) {
                currentPage = currentPage ?? this.props.pages[0]
                headers.forEach(header => {
                    if (!header.pages || header.pages.includes(currentPage.key)) {
                        visibleHeaders.push(header)
                    }
                });

                if (this.props.setFormStatus) {
                    this.props.setFormStatus('hasNext', !currentPage.isLastPage)
                }
            } else {
                visibleHeaders = headers
                if (this.props.setFormStatus) {
                    this.props.setFormStatus('hasNext', false)
                }

            }
            // console.log(this.props.pages)
            // console.log(this.props.initData)

            this.setState({ show: true, headers: visibleHeaders, currentPage }, () => {
                this.makeInitValue({ ...this.props.initData }, () => {
                    this.makeScoreInitValue({ ...this.props.scoreInitData }, () => {

                        if (this.props.setFormStatus) {
                            let isValid = this.validator(this.state.headers, this.state.data, true).valid
                            this.props.setFormStatus("canSubmit", isValid)
                            this.props.setFormStatus("hasBack", (this.state.lastPages?.length > 0))

                        }
                    })
                })

            })
        }

        // setTimeout(() => {
        //     this.setFormWidth()   
        // }, 500);
    }


    nextPage = (page) => {

        let isValid = this.validator(this.state.headers, this.state.data).valid


        if (isValid) {
            let currentPage = this.state.currentPage
            let lastPages = this.state.lastPages
            if (currentPage) {
                lastPages.push(currentPage)
            }
            let pages = this.props.pages


            if (currentPage.changeConditions) {

                let variables = { data: this.state.data }
                let nextPageKey

                currentPage.changeConditions.forEach((changeCondition, index) => {

                    let result = checkConditionGroup(changeCondition.conditions.root, variables)
                    // console.log(result)
                    // console.log(changeCondition)

                    if (result) {
                        nextPageKey = changeCondition.nextPage
                    }
                });

                // console.log(nextPageKey)

                if (nextPageKey) {
                    pages.forEach((page, index) => {
                        if (page.key == nextPageKey) {
                            currentPage = page
                        }
                    });
                } else {
                    currentPage = null
                }


            } else {


                let currentPageIndex

                pages.forEach((page, index) => {
                    if (page.key == currentPage.key) {
                        currentPageIndex = index
                    }
                });

                if (pages[currentPageIndex + 1]) {
                    currentPage = pages[currentPageIndex + 1]
                }

            }

            // this.props.setFormStatus('hasNext', !currentPage.isLastPage)
            // console.log(currentPage)
            if (currentPage) {
                this.setState({ show: false, currentPage, lastPages }, () => {
                    if (this.props.scrollToTop) {
                        this.props.scrollToTop()
                    }
                    this.init(currentPage)
                })
            }
        }

    }



    backPage = (cb) => {

        let lastPages = this.state.lastPages

        let page = lastPages[lastPages.length - 1]
        if (page !== null) {
            lastPages.pop()
            this.setState({ currentPage: page, lastPages }, () => {
                if (this.props.scrollToTop) {
                    this.props.scrollToTop()
                }
                this.init(page)
            })
        }
    }



    clearForm = () => {
        this.setState({ data: {} })
    }


    validator(headers, data, dontSetErrors) {

        let valid = true
        let errors = {}
        headers.forEach(header => {



            if (header.information?.required && !header.hideComponent) {

                let value = getObject(data, header.key)
                console.log('dataaaaaaaaavalue', value)

                if (header.type == 'ImageInput' || header.type == 'FileInput' || header.type == 'ImageProfileInput') {

                    if (!value || value === '') {
                        value = getObject(data, ('**files.' + header.key), 1)
                    }
                    if (!value || value === '') {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                } else {
                    // let value = getObject(data, header.key)
                    if (value == null || value === '') {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                }

                if (header.type == 'PhoneInput') {
                    // let value = getObject(this.state.data, header.key)
                    if (!value || value.length < 14) {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                }

                if (header.type == 'SubformInput') {
                    if (!value || value.length < 1) {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    } else {
                        value.forEach(subValue => {
                            // header.information.headers.forEach(subHeader => {
                            // console.log(subHeader)
                            let validator = this.validator(header.information.headers, subValue)
                            if (!validator.valid) {
                                valid = false
                                // console.log(validator)
                                errors[header.key] = '{{lang}}errors.required-field'

                                // errors[header.key] = validator.errors
                            }
                            // });
                        });
                    }
                }

                if (header.type == 'AddressInput') {
                    let formData = this["component-" + header.key].getForm()
                    if (!formData) {
                        valid = false
                        // errors[header.key] = '{{lang}}errors.required-field'
                    }
                }
            }
        })
        if (!dontSetErrors) {
            this.setState({ errors })
        }
        return { valid, errors }
    }




    makeInitValue(rawData, cb) {
        // let newData = {}
        // this.setState({ data: newData, show: false }, () => {
        //     if (data) {
        //         for (const [key, value] of Object.entries(data)) {
        //             this.state.headers.forEach(header => {
        //                 if (header.key === key) {
        //                     newData[key] = value
        //                 }
        //             });
        //         }
        //     }

        let data = rawData
        if (data == null) {
            data = {}
        }
        // console.log('makeINITDATA', data, this.state.headers)
        this.state.headers.forEach(header => {
            if (getObject(data, header.key) == null && header.information?.default != null) {
                // data[header.key] = header.information?.default
                setObject(data, header.key, header.information?.default)
            }

            if (getObject(data, header.key) == null && header.information?.defaultValue != null) {
                // data[header.key] = header.information?.defaultValue
                setObject(data, header.key, header.information?.defaultValue)

            }
        });

        // console.log(data)
        if (this.state.data) {
            data = { ...this.state.data, ...data }
        }

        // console.log(data)



        this.setState({ data: data, show: true }, () => {
            this.setFormWidth()
            this.checkDependencies()
            if (this.props.liveChange) {
                this.props.liveChange({ ...data }, true)
            }

            if (cb) {
                cb()
            }
            // console.log("this is data", this.state.data)

        })
    }

    makeScoreInitValue(rawData, cb) {
        // let newData = {}
        // this.setState({ data: newData, show: false }, () => {
        //     if (data) {
        //         for (const [key, value] of Object.entries(data)) {
        //             this.state.headers.forEach(header => {
        //                 if (header.key === key) {
        //                     newData[key] = value
        //                 }
        //             });
        //         }
        //     }

        let scoreData = rawData
        if (scoreData == null) {
            scoreData = {}
        }
        // console.log('makeINITDATA', scoreData, this.state.headers)
        this.state.headers.forEach(header => {
            if (getObject(scoreData, header.key) == null && header.information?.default != null) {
                // scoreData[header.key] = header.information?.default
                setObject(scoreData, header.key, header.information?.default)
            }

            if (getObject(scoreData, header.key) == null && header.information?.defaultValue != null) {
                // scoreData[header.key] = header.information?.defaultValue
                setObject(scoreData, header.key, header.information?.defaultValue)

            }
        });

        // console.log(scoreData)
        if (this.state.scoreData) {
            scoreData = { ...this.state.scoreData, ...scoreData }
        }

        // console.log(scoreData)



        this.setState({ scoreData: scoreData, show: true }, () => {
            this.setFormWidth()
            this.checkDependencies()
            if (this.props.liveChange) {
                this.props.liveChange({ ...scoreData }, true)
            }

            if (cb) {
                cb()
            }
            // console.log("this is data", this.state.data)

        })
    }

    setFormWidth = () => {
        if (this.form) {
            this.setState({ width: this.form.getBoundingClientRect().width }, () => {
                // console.log(this.state.width)
            })
        }
    }

    changeFiles = (value, key, extra) => {
        let data = this.state.data ?? {}

        if (data['**files'] == null) {
            data['**files'] = {}
        }
        if (value) {
            value.formType = ''
        }

        this.state.headers.forEach(header => {
            if (value && header.key == key) {
                value.formType = header.type
                // value.single = header.information?.single
            }
        });

        data['**files'][key] = value
        // console.log(data)
        this.setState({ data })
    }

    changeValue = (key, value, extra, full, dontUpdate) => {


        let data = { ...this.state.data }

        data = setObject(data, key, value, extra?.append, null, true)

        this.setState({ data }, () => {

            // console.log('finaldatais',data)
            this.changeDependency(key, value)
            if (this.props.liveChange && !dontUpdate) {
                this.props.liveChange(data, false, key, value, extra, full)
            }

            if (this.props.setFormStatus) {
                // if (this.validator(this.state.headers, this.state.data).valid) {
                let isValid = this.validator(this.state.headers, this.state.data, true).valid
                this.props.setFormStatus("canSubmit", isValid)
                // }
            }
            // }
            // } else {

            //     console.log("dontUpdate")
            //     this.state.data = data
            // }

        })

    }

    changeScoreValue = (key, value, extra, full, dontUpdate) => {

        let scoreData = { ...this.state.scoreData }

        scoreData = setObject(scoreData, key, value, extra?.append, null, true)
        console.log('valueeeee', scoreData)

        this.setState({ scoreData }, () => {
            if (this.props.liveChange) {
                this.props.liveChange()
            }
            // this.props.setData('scoreData', scoreData)
        })

    }


    // setError = (key, value) => {
    //     let errors = this.state.errors
    //     errors[key] = value
    //     this.setState({ errors })

    // }

    // setValid = (key, value) => {
    //     let valid = this.state.valid
    //     valid[key] = value
    //     this.setState({ valid })
    // }


    setStatus = (type, key, value) => {
        let errors = this.state.errors
        let valid = this.state.valid


        delete errors[key]
        delete valid[key]

        if (type == 'error') {
            errors[key] = value
        }
        if (type == 'valid') {
            valid[key] = value
        }

        this.setState({ errors, valid })

        if (this.props.liveChange) {
            this.props.liveChange(this.state.data, false, key, value, null, valid)
        }

    }



    formColBuilder(col) {
        let finalCol = 'col-12'

        // console.log(this.state.width)
        if (500 < this.state.width && col) {
            finalCol = 'col-' + col
        }
        if (this.props.col) {
            finalCol = 'col-' + this.props.col
        }

        finalCol = " " + finalCol + " "

        return finalCol
    }

    changeTab = (section) => {

        this.setState({ currentTab: section })
    }

    toggleSection = (section) => {
        let hiddenSections = this.state.hiddenSections ?? {}
        if (hiddenSections[section.key]) {
            delete hiddenSections[section.key]
        } else {
            hiddenSections[section.key] = true
        }

        this.setState({ hiddenSections })
    }

    changeInputDisabledStatus = (key, status) => {
        let headers = this.state.headers
        // console.log(key, status)
        headers.forEach(header => {
            if (header.key == key) {
                // console.log('key',key)
                header.information.disabled = !status
                // console.log('header',header)
            }
        });

        this.setState({ headers }, () => {
            console.log('this.props.setData', this.props)
            if (this.props.setData) {
                console.log(true, 'data')
                this.props.setData('headers', this.state.headers)
            }
        })
    }



    renderSection(headers) {

        return (
            <section className={"w-100 form " + (this.props.formClass ?? 'dafault-form')} ref={(el) => this.form = el}>

                <div className="row m-0 ">
                    {headers && headers.map((header, index) => {
                        let Component = inputComponents[header.type]
                        let data = getObject(this.state.data, header.key)//this.state.data[header.key] ? this.state.data[header.key] : ''
                        let correctData
                        let correct = false
                        if (this.props.showCorrect && this.props.fullData.values.hasAnswerSheet) {
                            correctData = getObject(this.props.answerData, header.key)

                            if (correctData == data) {
                                correct = true
                            }
                        }
                        let scoreData = getObject(this.state.scoreData, header.key)//this.state.data[header.key] ? this.state.data[header.key] : ''
                        let files
                        if (this.state.data && this.state.data['**files']) {
                            files = getObject(this.state.data['**files'], header.key)//this.state.data[header.key] ? this.state.data[header.key] : ''
                        }
                        header.information.disabled = this.props.disableInputs ?? header.information.disabled
                        let information = header.information

                        if (header.section && this.state.hiddenSections[header.section]) {
                            return
                        }
                        // console.log(header)
                        // console.log(header.key)

                        // console.log(data)
                        // console.log(this.state.data)

                        // console.log(header.information?.default)

                        if (data == null && header.information?.default != null) {
                            // console.log(header.information?.default)

                            data = header.information?.default
                        }
                        if (scoreData == null && header.information?.default != null) {
                            // console.log(header.information?.default)

                            scoreData = ''
                        }

                        if (header.type == 'SectionIndicator') {
                            return (
                                <div key={header.key} onClick={() => this.toggleSection(header)} className="col-12 mb-3 mt-2 text-start SectionIndicator  cursor-pointer" >
                                    <div className={'flexcb w-100  ' + (this.state.hiddenSections[header.key] ? 'pb-3' : '')} style={{ borderBottom: this.state.hiddenSections[header.key] ? '1px solid #eee' : '1px solid transparent' }}>
                                        <p style={{ color: information?.color ?? '#000', fontWeight: information?.fontWeight ?? '600', fontSize: information?.fontSize ?? 20 }} >{checkTranslation(header?.information?.label)}</p>
                                        <img src="/images/nexts.png" className={" " + (this.state.hiddenSections[header.key] ? '' : 'rotate-90')} height="14px" />
                                    </div>
                                </div>
                            )
                        } else if (header.type == 'StaticText') {
                            return (
                                <div key={header.key} className="col-12  mt-2 text-start StaticText" style={{ marginBottom: information?.marginBottom }}>
                                    <p style={{ color: information?.color, fontWeight: information?.fontWeight, fontSize: information?.fontSize }} >{checkTranslation(header?.information?.label)}</p>

                                </div>
                            )
                        }
                        else if (header.type == 'PageIndicator') {
                            return (
                                <div key={header.key} className="col-12 mb-2 text-start ">
                                    <button onClick={() => this.props.variables[header.information.function](header.information.inputData)} className="p-0 w-100 flexcb">
                                        <label className={'text-small mrd-1 mld-1  ' + (header.information?.required ? 'required' : '')}>{checkTextTranslation(header.information?.label)}</label>
                                        <img src="/images/nexts.png" height="14px" />
                                    </button>
                                </div>
                            )
                        } else if (header.type == 'FakeCol') {
                            return (
                                <div key={index} className={"p-0 " + this.formColBuilder(header.col) + (index !== header.length - 1 ? ' mb-3' : '')}>
                                </div>
                            )

                        } else if (header.type == 'FormSection') {
                            return (
                                <div className="w-100 mb-3 p-0" key={header.key}>
                                    <Component changeValue={this.changeTab} data={this.state.currentTab} forceInputUpdate={this.props.forceInputUpdate} functionsHandler={this.props.functionsHandler} ref={el => this["component-" + header.key] = el} header={header} setStatus={this.setStatus} variables={this.props.variables} optionsList={this.props.optionsList} />
                                </div>
                            )
                        } else if (header.type == 'SwitchInput') {
                            if (Component && !header.hideComponent && (header.tab == null || header.tab == this.state.currentTab)) {

                                return (
                                    <div className={"form-label mb-4  d-flex flex-column " + ((this.props.nopadding ? ' p-0 ' : '') + (this.formColBuilder(header.col)))} key={header.key} >
                                        <div className={" d-flex flex-column  " + ((header.information?.disabled || this.props.disableInputs) ? ' disabled ' : '')}>
                                            {/* (header.information.inputClass ?? (this.props.inputClass ? this.props.inputClass : ' default-input-view ')) */}

                                            <span className='flexc pb-2' style={{ alignItems: 'baseline' }}>
                                                <label className={'  label-text switch-label  mld-3 mrd-1  mb-0 flex-1 ' + (header.information?.required ? 'required' : '')} >{checkTextTranslation(header.information?.label)}</label>
                                                {this.props.showCorrect && this.props.fullData.values.hasAnswerSheet && (
                                                    <>
                                                        {correct ? (
                                                            <>
                                                                <img src='/assets/icons/inquiry/tick.svg' style={{ width: '20px' }} />
                                                            </>
                                                        ) : (
                                                            <>
                                                                <img src='/assets/icons/inquiry/cancel.svg' style={{ width: '20px' }} />
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                                {(this.props.header.information.showSecond || this.props.scoreData) && (
                                                    <div className='mx-1 score_input' style={{}}>
                                                        <NumberInput ref={el => this["component--" + header.key] = el} header={{ type: 'NumberInput', information: { disabled: this.props.disableInputs ?? false, placeholder: "{{lang}}Score" } }} functionsHandler={this.props.functionsHandler} forceInputUpdate={this.props.forceInputUpdate} builderHeaders={this.props.builderHeaders} data={data} fullData={this.state.data} params={this.props.params} files={files} changeFiles={this.changeFiles} changeValue={this.changeScoreValue} setStatus={this.setStatus} variables={this.props.variables} optionsList={this.props.optionsList} width={this.props.width} headers={this.props.headers} colors={this.props.colors} inputClass={this.props.inputClass} extra={this.props.extra} />
                                                    </div>
                                                )}
                                            </span>
                                            {this.props.header.information.showFirst && (

                                                <Component ref={el => this["component-" + header.key] = el} header={header} data={data} files={files} changeFiles={this.changeFiles} forceInputUpdate={this.props.forceInputUpdate} functionsHandler={this.props.functionsHandler} changeValue={this.changeValue} setStatus={this.setStatus} variables={this.props.variables} optionsList={this.props.optionsList} width={this.props.width} />
                                            )}

                                            {/* {header.information?.help && (
                                                <div className='px-1'>
                                                    <HelpButton data={header.information?.help} />
                                                </div>
                                            )} */}
                                        </div>

                                        {header.information?.hint && (
                                            <div className={" mt-1 mld-2  text-start mt-2 "}>
                                                <p className='text-smaller  ' style={{ color: '#777', cursor: 'default' }} >{checkTextTranslation(header.information?.hint)}</p>
                                            </div>
                                        )}
                                    </div>
                                )
                            }
                        } else if (header.type == 'LicenseInput') {
                            if (Component && !header.hideComponent && (header.tab == null || header.tab == this.state.currentTab)) {

                                return (
                                    <div className={"form-label mb-4  d-flex flex-column " + ((this.props.nopadding ? ' p-0 ' : '') + (this.formColBuilder(header.col)))} key={header.key} >
                                        <div className={" flexc  " + ((header.information?.disabled || this.props.disableInputs) ? ' disabled ' : '')}>

                                            <Component ref={el => this["component-" + header.key] = el} header={header} data={data} files={files} changeFiles={this.changeFiles} forceInputUpdate={this.props.forceInputUpdate} functionsHandler={this.props.functionsHandler} changeValue={this.changeValue} setStatus={this.setStatus} variables={this.props.variables} optionsList={this.props.optionsList} width={this.props.width} />

                                        </div>

                                        {header.information?.hint && (
                                            <div className={" mt-1 mld-2  text-start mt-2 "}>
                                                <p className='text-smaller  ' style={{ color: '#777', cursor: 'default' }} >{checkTextTranslation(header.information?.hint)}</p>
                                            </div>
                                        )}
                                    </div>
                                )
                            }
                        } else if (header.type == 'SubformInput' || header.type == 'VariantsInventory' || header.type == 'CombinedInput' || header.type == 'AddressInput') {
                            if (Component && !header.hideComponent && (header.tab == null || header.tab == this.state.currentTab)) {
                                return (
                                    <div className={" w-100   " + ((this.props.nopadding ? ' p-0 ' : '') + (header.type == 'AddressInput' ? " mb-0 " : ' mb-3 ') + (this.formColBuilder(header.col)))} key={header.key}>
                                        <div className={'br-8 ' + (this.state.errors[header.key] ? ' error-input ' : ' ')}>
                                            {header.information?.label && (
                                                <div className={"col-12 flexc form-label text-start p-0"}>
                                                    <label style={{}} className={'label-text  py-2 mrd-1 mld-1  ' + (header.information?.required ? 'required' : '')}>{checkTextTranslation(header.information?.label)}</label>
                                                    {this.props.showCorrect && this.props.fullData.values.hasAnswerSheet && (
                                                        <>
                                                            {correct ? (
                                                                <>
                                                                    <img src='/assets/icons/inquiry/tick.svg' style={{ width: '20px' }} />
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <img src='/assets/icons/inquiry/cancel.svg' style={{ width: '20px' }} />
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                    {(this.props.header.information.showSecond || this.props.scoreData) && (

                                                        <div className='mx-2 score_input' style={{}}>
                                                            <NumberInput ref={el => this["component--" + header.key] = el} header={{ type: 'NumberInput', information: { disabled: false, placeholder: "{{lang}}Score" } }} functionsHandler={this.props.functionsHandler} forceInputUpdate={this.props.forceInputUpdate} builderHeaders={this.props.builderHeaders} data={scoreData} fullData={this.state.data} params={this.props.params} files={files} changeFiles={this.changeFiles} changeValue={this.changeScoreValue} setStatus={this.setStatus} variables={this.props.variables} optionsList={this.props.optionsList} width={this.props.width} headers={this.props.headers} colors={this.props.colors} inputClass={this.props.inputClass} extra={this.props.extra} />
                                                        </div>
                                                    )}
                                                    {/* {header.information?.help && (
                                                        <HelpButton data={header.information?.help} />
                                                    )} */}
                                                </div>)}
                                            {this.props.header.information.showFirst && (
                                                <Component ref={el => this["component-" + header.key] = el} functionsHandler={this.props.functionsHandler} forceInputUpdate={this.props.forceInputUpdate} header={header} data={data} fullData={this.state.data} files={files} changeFiles={this.changeFiles} changeValue={this.changeValue} setStatus={this.setStatus} variables={this.props.variables} optionsList={this.props.optionsList} width={this.props.width} inputClass={this.props.inputClass} extra={this.props.extra} />
                                            )}
                                        </div>
                                        {header.information?.hint && (
                                            <div className={" mt-1 mld-2  text-start mt-2 "}>
                                                <p className='text-smaller  ' style={{ color: '#777', cursor: 'default' }} >{checkTextTranslation(header.information?.hint)}</p>
                                            </div>
                                        )}

                                        {this.props.errors && this.props.errors[header.key] && (
                                            <div className={" mt-1 mld-2 text-start "}>
                                                <small style={{ color: '#ee5050' }}>{checkTextTranslation(this.props.errors[header.key])}</small>
                                            </div>
                                        )}

                                        {this.state.errors && this.state.errors[header.key] && (!this.props.errors || !this.props.errors[header.key]) && (
                                            <div className={" mt-1 mld-2 text-start "}>
                                                <small style={{ color: '#ee5050' }}>{checkTextTranslation(this.state.errors[header.key])}</small>
                                            </div>
                                        )}

                                    </div>
                                )
                            }
                        }
                        else {


                            if (Component && !header.hideComponent && (header.tab == null || header.tab == this.state.currentTab)) {


                                return (
                                    <div key={header.key} className={"p-0 " + this.formColBuilder(header.col) + (index !== header.length - 1 ? (' mb-3 ') : '')}>



                                        <div className="row m-0">
                                            {(header.information?.label && !header.information?.withDiscount) && (
                                                <div className={"col-12 flexcb  form-label text-start " + (this.props.nopadding ? 'p-0' : '')}>
                                                    {header.information?.label && (
                                                        <span className='flexcb w-100' style={{ alignItems: 'baseline' }}>

                                                            <p style={{}} className={'label-text  py-2 mrd-1 mld-1 flex-1 ' + (header.information?.required ? ' required ' : '')}>{checkTextTranslation(header.information?.label)}</p>
                                                            {this.props.showCorrect && this.props.fullData.values.hasAnswerSheet && (
                                                                <>
                                                                    {correct ? (
                                                                        <>
                                                                            <img src='/assets/icons/inquiry/tick.svg' style={{ width: '20px' }} />
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <img src='/assets/icons/inquiry/cancel.svg' style={{ width: '20px' }} />
                                                                        </>
                                                                    )}
                                                                </>
                                                            )}
                                                            {(this.props.header.information.showSecond || this.props.scoreData) && (
                                                                <div className='mx-1 score_input d-flex' style={{}}>
                                                                    <NumberInput ref={el => this["component--" + header.key] = el} header={{ type: 'NumberInput', id: header.id, key: header.key, information: { disabled: this.props.disableInputs ?? false, placeholder: "{{lang}}Score" } }} data={scoreData} fullData={this.state.scoreData} params={this.props.params} changeValue={this.changeScoreValue} width={this.props.width} headers={this.props.headers} colors={this.props.colors} extra={this.props.extra} />
                                                                </div>
                                                            )}
                                                            {/* {header.information?.help && (

                                                                <HelpButton data={header.information?.help} />
                                                            )} */}
                                                        </span>
                                                    )}
                                                </div>
                                            )}


                                            {this.props.header.information.showFirst && (
                                                <div className={("col-12 ") + (this.props.nopadding ? 'prd-2 pld-0' : '')} >
                                                    <div className={"flexc br-8  " + (((header.information?.disabled || this.props.disableInputs) ? ' disabled ' : '') + ((header.information?.inputClass) ?? (header.information?.withDiscount ? "" : ((this.props.inputClass) ? this.props.inputClass : 'default-input-view ')) + ' ') + ((this.state.valid[header.key] ? ' valid-input ' : ' ') + (this.state.errors[header.key] ? ' error-input ' : ' ')))} style={{ maxWidth: this.state.width > 500 ? header.maxWidth : null }} >

                                                        {/* {String(header.information?.disabled)} */}
                                                        {header.information?.icon && (
                                                            <img className="mrd-3" src={header.information?.icon} height="25px" alt="icon" />
                                                        )}
                                                        <div className={'w-100 ' + header?.information?.componentClass ?? ''}>
                                                            <Component ref={el => this["component-" + header.key] = el} header={header} functionsHandler={this.props.functionsHandler} forceInputUpdate={this.props.forceInputUpdate} builderHeaders={this.props.builderHeaders} data={data} fullData={this.state.data} params={this.props.params} files={files} changeFiles={this.changeFiles} changeValue={this.changeValue} setStatus={this.setStatus} variables={this.props.variables} optionsList={this.props.optionsList} width={this.props.width} headers={this.props.headers} colors={this.props.colors} inputClass={this.props.inputClass} extra={this.props.extra} />
                                                        </div>

                                                    </div>
                                                </div>
                                            )}

                                            {/* {this.props.hasScore&&(
    <div className={"col-3 " + (this.props.nopadding ? 'prd-2 pld-0' : '')} >
    <div className={"flexc br-8  " + ((header.information?.disabled ? ' disabled ' : '') + ((header.information?.inputClass) ?? (header.information?.withDiscount ? "" : ((this.props.inputClass) ? this.props.inputClass : 'default-input-view ')) + ' ') + ((this.state.valid[header.key] ? ' valid-input ' : ' ') + (this.state.errors[header.key] ? ' error-input ' : ' ')))} style={{ maxWidth: this.state.width > 500 ? header.maxWidth : null }} >

        {header.information?.icon && (
            <img className="mrd-3" src={header.information?.icon} height="25px" alt="icon" />
        )}

        <div className={'w-100 ' + header?.information?.componentClass ?? ''}>
            <NumberInput ref={el => this["component--" + header.key] = el} header={{type:'NumberInput',information:{disabled: false,placeholder: "{{lang}}Score"}}} functionsHandler={this.props.functionsHandler} forceInputUpdate={this.props.forceInputUpdate} builderHeaders={this.props.builderHeaders} data={data} fullData={this.state.data} params={this.props.params} files={files} changeFiles={this.changeFiles} changeValue={this.changeValue} setStatus={this.setStatus} variables={this.props.variables} optionsList={this.props.optionsList} width={this.props.width} headers={this.props.headers} colors={this.props.colors} inputClass={this.props.inputClass} extra={this.props.extra} />
        </div>


    </div>
</div>
)} */}

                                            {header.information?.hint && (

                                                <div className={" mt-0 pld-2 text-start mt-0 w-100" + (this.props.nopadding ? '' : ' px-3 ')}>
                                                    <p className='text-smaller text-semibold ' style={{ color: '#777', cursor: 'default' }} >{checkTextTranslation(header.information?.hint)}</p>
                                                </div>
                                            )}

                                            {this.props.errors && this.props.errors[header.key] && (
                                                <div className={" mt-1 mld-2 text-start w-100 " + (this.props.nopadding ? '' : ' px-3 ')}>
                                                    <small style={{ color: '#ee5050' }}>{checkTextTranslation(this.props.errors[header.key])}</small>
                                                </div>
                                            )}

                                            {this.state.errors && this.state.errors[header.key] && (!this.props.errors || !this.props.errors[header.key]) && (
                                                <div className={" mt-1 mld-2 text-start w-100 " + (this.props.nopadding ? '' : ' px-3 ')}>
                                                    <small style={{ color: '#ee5050' }}>{checkTextTranslation(this.state.errors[header.key])}</small>
                                                </div>
                                            )}

                                        </div>
                                    </div>
                                )
                            }

                        }


                    })}

                    {this.props.errors && (typeof this.props.errors == 'string') && (
                        <div className="col-12 text-start">
                            <small style={{ color: '#ee5050' }}>{checkTextTranslation(this.props.errors)}</small>
                        </div>
                    )}



                    {/* <ButtonAnimated
            iconwidth='24px'
            onClick={this.addClicked}
            title='New Record'
            icon='/assets/icons/plus-white.svg'
            bg='linear-gradient(to right, #5856D6, #7D7AFF)'
        /> */}

                </div>

            </section>
        )
    }

    render() {

        if (this.state.show && this.state.headers) {
            if (!this.state.currentPage || !this.state.currentPage.sections) {
                return (
                    <div className={'w-100  ' + (this.props.nopadding ? ' p-0 ' : '')} style={this.props.sectionStyle}>
                        {this.renderSection(this.state.headers)}
                    </div>
                )
            } else {
                return (
                    <div className='w-100'>

                        {this.state.currentPage.sections.map((section, index) => {

                            let headers = this.state.headers.filter((a) => (a.section == section.key && !a.hideComponent))
                            if (headers && headers.length > 0) {
                                return (
                                    <div style={this.props.sectionStyle}>
                                        {section?.information?.label && (
                                            <div className='px-3 mb-3 pb-2' style={{ borderBottom: '1px solid #eee' }}>
                                                <p className='text-bold text-semibig px-1'>{checkTranslation(section?.information?.label)}</p>
                                            </div>
                                        )}
                                        <div className='px-1'>
                                            {this.renderSection(headers)}
                                        </div>
                                    </div>
                                )
                            }
                        })}

                    </div>
                )
            }

        } else {
            return (<div></div>)
        }
    }
}

export default AnswerSheetForm;